<script>
    import { onMount } from 'svelte';
    import { quintOut } from 'svelte/easing';
    import { crossfade, fly, fade } from 'svelte/transition';
    import { flip } from 'svelte/animate';
	import { db, hashtag } from '../stores.js';

    let w;
    let breakpoint = 532;
    let tabShown = "todo";
    let tasks = [];
    // let tasks = [
    //     { id: 1588508377849, name: "setup OUR show email blast", completed: false },
    //     { id: 1588508403673, name: "look for yeti mic and webcam", completed: false },
    //     { id: 1588508486735, name: "work on hiphoptimer layout", completed: false },
    //     { id: 1588508526133, name: "update lifelong.dev with ticreacttoe.com info", completed: false },
    //     { id: 1588509254684, name: "iron", completed: false },
    //     { id: 1588509262516, name: "get mail", completed: false },
    //     { id: 1588509654167, name: "pay bills", completed: false },
    //     { id: 1588509906553, name: "watch rick and morty", completed: false },
    //     { id: 1588521519171, name: "post show to social media", completed: false },
    //     { id: 1589740205112, name: "do a sketch for new OUR show site", completed: false }
    // ];

    let newTask = "";
    let taskList;
    let showTaskList = false;

    // let hashtag;

    const [send, receive] = crossfade({
        duration: d => Math.sqrt(d * 200),
        fallback(node, params) {
            const style = getComputedStyle(node);
            const transform = style.transform === 'none' ? '' : style.transform;

            return {
                duration: 600,
                easing: quintOut,
                css: t => `
                    transform: ${transform} scale(${t});
                    opacity: ${t}
                    `
            };
        }
    });

    $: taskCompleted = tabShown === "todo" ? false : true;
    $: tasksTodo = tasks.filter(task => task.completed===false).length;
    $: showTaskList = w>breakpoint;
    $: completedTasks = tasks.filter(task => task.completed===true);
    $: tweetURL = `https://twitter.com/intent/tweet?text=%23WorkinOnIt Making progress at https://untilit.works (a @lifelongdev site) %23${$hashtag}` + completedTasks.map(task => `%0D%0A%E2%9C%85 ${task.name}`).join(" ");
    $: tweetURLSanitized = tweetURL.replaceAll('#', '%23');

    onMount(async() => {
        //Check for tasks in local storage
        if (localStorage.getItem('tasks')){
            // console.log('get tasks from local storage! ',JSON.parse(localStorage.getItem('tasks')) )
            tasks = [...tasks, ...JSON.parse(localStorage.getItem('tasks'))];
            // console.log('onmount tasks: ', tasks);
        }
        // $db.collection("data").doc("status")
		// 	.onSnapshot((doc) => {
		// 		console.log("current data!: ", doc.data());
		// 		hashtag = doc.data().hashtag;
		// 	});

        console.log("$hashtag: ", $hashtag);

    })
    
    function saveTasks() {
        // console.log('save tasks');
        localStorage.setItem('tasks', JSON.stringify(tasks));
    }

    function addTask(taskInput) {
        // console.log('add Task');
        let intervalID;
        if (newTask !== ''){
            // console.log('new task: ', newTask);
            tasks = [...tasks, { id: Date.now(), name: newTask, completed: false }];
            newTask = '';
            intervalID = setTimeout(() => { taskList.scrollTo(0, taskList.scrollHeight); clearTimeout(intervalID); }, 250);
            // console.log('tasklist scroll height: ',taskList.scrollHeight);
            saveTasks();
        }
    }

    function updateTask(editedTask, updatedTaskName){
        // console.log('update task',editedTask, updatedTaskName);
        let foundIndex = tasks.findIndex((task) => task.id === editedTask.id);
        tasks[foundIndex].name = updatedTaskName;
        // console.log('found: ', foundIndex);
        saveTasks();
    }

    function removeTask(removedTask){
        // console.log('remove task: ',removedTask);
        tasks = tasks.filter(task => task !== removedTask);
        saveTasks();
    }

    function updateStatus(updatedTask) {
        // console.log('updateStatus');
        let foundIndex = tasks.findIndex((task) => task.id === updatedTask.id);
        tasks[foundIndex].completed = !updatedTask.completed;

        saveTasks();
    }

</script>
<svelte:window bind:innerWidth={w}/>
{#if showTaskList}
    <div id="taskContainer" class:mobile={w<=breakpoint}>
        <div id="taskTabs">
            <div class="taskTab" class:selected={tabShown === "todo"} on:click={ () => tabShown = "todo" }><input type=checkbox disabled>todo</div>
            <div class="taskTab" class:selected={tabShown === "done"} on:click={ () => tabShown = "done" }><input type=checkbox checked disabled>done</div>
        </div>
        <div id="taskList" bind:this={taskList}>
            {#each tasks.filter(t => t.completed === taskCompleted) as task (task.id) }
                <div class="task" in:fly="{{ y: 200, duration: 500 }}" animate:flip>
                    <div>
                        <input type=checkbox bind:checked={task.completed} on:click={() => updateStatus(task)}>
                    </div>
                    <div contenteditable="true" on:blur={(e) => updateTask(task,e.target.innerText)}>{task.name}</div>
                    <div><button on:click={()=>removeTask(task)}>X</button></div>
                </div>
            {/each}
        </div>
        <div id="taskForm">
            <span id="twitterBtn"><a href="{tweetURLSanitized}" target="_blank"><img src="/twitter-square-blue.svg" alt="twitter logo"></a></span>
            <input type="text" id="taskInput" placeholder="Add a task" bind:value={newTask} on:keydown={e=> e.key === "Enter" && addTask()}>
            <button id="taskAddButton" on:click={addTask}>+</button>
        </div>
    </div>
{/if}
{#if w <= breakpoint}
    <div id="mobile-header">
        <div><button on:click={()=>showTaskList = !showTaskList}>{showTaskList ? "Hide": "Show"}</button></div>
        <div id="todos-text">
            {tasksTodo} Task{tasksTodo === 1 ? '' : 's'} Todo
        </div>
    </div>
{/if}

<style>
    #taskContainer {
        color:white;
        height: 100%;
        width: 100%;
        
    }
    #taskTabs {
        display: flex;
        justify-content: space-around;
        font-size: 3rem;
    }
    .taskTab {
        width: 50%;
        border: solid white;
        border-width: 0;
        cursor: pointer;
    }
    .taskTab.selected { 
        border-width: 0 0 1px;        
    }
    .taskTab > input {
        height: 2rem;
        width: 2rem;
    }
    #taskList {
        border: solid white;
        border-width: 0 1px 1px;
        /* height: 100%; */
        height: 300px;
        /* height: 200px; */
        overflow-y: auto;
        padding: 10px;
    }
    .task {
        /* max-width: 330px; */
        margin: 10px 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: rgba(255, 255, 255, .7);
        /* opacity: 1; */
        padding: 6px;
        color: black;
        border-radius: 5px;
    }
    .task > div > input {
        width: 20px;
        height: 20px;
        padding: 0;
        margin: 0;
    }
    .task > div > button {
        width: 35px;
        height: 35px;
        padding: 0;
        margin: 0;
    }
    #taskForm {
        display: flex;
    }
    #taskInput {
        width: 100%;
        margin: 0;
    }
    #taskAddButton {
        padding: 0;
        margin: 0;
        width: 40px;
    }
    .mobile {
        background-color: rgba(0,0,0,.7);
    }
    #mobile-header {
        background-color: white;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 5px;
    }
    #mobile-header > div > button {
        margin: 0;
    }
    #todos-text {
        font-size: 30px;
    }
    button {
        cursor: pointer;
    }
    #twitterBtn {
        /* width: 40px; */
        height: 37px;
        cursor: pointer;
    }
    #twitterBtn img {
        width: 37px;
        height: 37px;
    }
</style>